import { appConfig } from '../../../config/config.js'
import { browserAppUser } from '../../../helpers/app-data-loaders/app-user.js'
import { setElementHtml } from '../../../helpers/generic-js/dom.js'
import { applyRestrictions } from '../../../modules/user/html-parser.js'

import htmlTemplateIndex from './index.html'
import './styles.css'

export async function showPageLogin () {
  console.log('showPageLogin()')

  // Prepare the html
  const appUserData = browserAppUser.data
  let htmlIndex = htmlTemplateIndex
  htmlIndex = applyRestrictions(htmlIndex, { userData: appUserData.appUser })

  // Inject in the page
  setElementHtml(appConfig.contentElementId, htmlIndex)

  // Set page title
  document.title = ['Sign up/Log in Zenflow'].join(' ')

  // Additional
  showSignInButtons(appUserData.appUser)
}

function showSignInButtons (appUser) {
  console.log('showSignInButtons', appUser)

  if (appUser?.xero_profile) {
    const xeroButton = document.querySelector('#loginLinks [d-login-method="xero"]')
    xeroButton?.classList.add('is-hidden')
  }

  if (appUser?.google_profile) {
    const googleButton = document.querySelector('#loginLinks [d-login-method="google"]')
    googleButton?.classList.add('is-hidden')
  }
}
